import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Fab from '@material-ui/core/Fab';
//import config from '../../../config';
import { config  } from '../../../config';
import ProfileImageUpload2 from '../fileUpload/ProfileImageUpload2';
import Tooltip from '@material-ui/core/Tooltip';
import SweetAlert from 'react-bootstrap-sweetalert'
import { putUserUpdateApi } from '../../../api/users';
import IntlMessages from 'util/IntlMessages';
import {history} from '../../../store';
import { userInst } from '../../../util/utilFunction';
import { connect } from 'react-redux';


const auth_check = (user, roles) => {
  const cond = ((roles.some(r => r.id === 1)) || (!["YK","TTK","TDK","AKM","ATAM"].some(x=>x === user.inst)))
  return cond
}

  class UserProfileCard extends React.Component {

 state = {
  avatarPath : ''+config.apiUrl + this.props.user.profileImageUrl,
  warning:false,
  warningText:"",
  user : this.props.user
 }
componentDidMount = ()=>{
 // //console.log("görüntülenen user 1 : ",this.props.user);

}

componentWillReceiveProps= (nextProps)=>{

////console.log("son seçilen 2: ",nextProps.user )
  this.setState({
    avatarPath : ''+config.apiUrl + nextProps.user.profileImageUrl,
    user : nextProps.user
  });
}
 onChangeAvatar = (path) =>{
    this.setState({avatarPath: config.apiUrl + path})
  }

  onChangeEnableUserOnConfirm = async() =>{
    const oldUser = this.state.user;
    const user = {
      id : oldUser.id,
      enabled : oldUser.enabled === 1 ? 0 : 1
    }
        const result = await putUserUpdateApi(user);

        if(result.status)
        {
          oldUser.enabled = user.enabled;
          this.setState({user:oldUser})
        } else{
          ////console.log("result error",result.error);
         if(result.error.status === 403)
            history.push("/bbs/error403");
         else
            history.push("/bbs/error404");
        }
      
      

   
    }

  onChangeEnableUser = ()=>{
    this.setState({
      warning:true,
      warningText :`${this.state.user.name} ${this.state.user.surname}  İsimli kullanıcının hesabını ${this.state.user.enabled===1 ? " Kapatmak " : " Aktif Yapmak "} istediğinizden emin misiniz?` 
    })
  }

render(){
  const {headerStyle,user} = this.props;

        return (
          <div className="jr-card text-center">
            <div className={`jr-card-header-color ${headerStyle}`}>
              <div className="jr-card-header-top">
                <IconButton className="jr-fs-lg text-white" aria-label="Menu"><i className="zmdi zmdi-menu"/></IconButton>
                <IconButton className="icon-btn p-1 text-white ml-auto"><i className="zmdi zmdi-more-vert"/></IconButton>
              </div>

              <img className="rounded-circle size-90 avatar-shadow mb-3"
                  src={this.state.avatarPath} alt="Team Member"/>
              {auth_check(user, this.props.authUser.userRoles) && <ProfileImageUpload2 user={user} onChangeAvatar={this.onChangeAvatar}   userId={user.id} ></ProfileImageUpload2>}

              <div className="jr-card-hd-content">
                <h5 className="mb-0 text-white">{user.title+' '+user.name +' '+user.surname}</h5>
                <p className="jr-fs-sm mb-0 text-grey text-lighten-2"><IntlMessages id="user"/> : {this.state.user.enabled === 1 ? <IntlMessages id="user.table.activation.active"/> : <IntlMessages id="user.table.activation.closeAccount"/>}</p>
              </div>
              <Tooltip id="tooltip-icon" title={user.enabled === 1 ? <IntlMessages id="user.table.activation.button.tooltip.notactive"/> : <IntlMessages id="user.table.activation.button.tooltip.active"/>} placement="top">
                  <Fab className="jr-badge-up bg-success" onClick={this.onChangeEnableUser}><i className="zmdi zmdi-mail-send"/></Fab>
              </Tooltip>
            </div>
            <div className="jr-card-body pt-2">
              <p className="card-text"> {userInst(user.inst)}</p>
            </div>

             <SweetAlert                     showCancel
 show={this.state.warning} warning title={this.state.warningText} confirmBtnBsStyle="danger" confirmBtnText={ <IntlMessages id="button.yes"/>} cancelBtnText={ <IntlMessages id="button.cancel"/>}
                    onConfirm={()=>{
                                      this.onChangeEnableUserOnConfirm()

                      this.setState({warning: false , warningText:""});  
                    }}
                    onCancel={()=>{
                      this.setState({warning: false , warningText:""})
                    }
                      }>
                     
             </SweetAlert> 

          </div>
        )
      } 
};

const mapStateToProps = ({auth}) => {
  const {authUser} = auth;
  return { authUser};
};

export default connect(mapStateToProps)(UserProfileCard);